import React, { Component } from 'react'

import FaIcon from '../components/FaIcon'
import { Button } from 'antd'


export default class Badge extends Component {

    render() {
        return (
            <Button className="auto-save-button" shape="circle" size="large" style={{ position: "fixed", right: 25, bottom: 94, width: 50, height: 50}} onClick={this.props.onClick}>
                <span className="fa-layers fa-fw fa-lg">
                    <FaIcon icon="save" />
                    { this.props.isDirty
                        ? <FaIcon icon={["fas", "spinner"]} spin transform="shrink-2 down-5 right-5" color="orange"/>
                        : <FaIcon icon={["fas", "check"]} transform="shrink-2 down-5 right-5" color="green"/>
                    }
                </span>
            </Button>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/AutoSaveButton.js